import React from 'react'
import {
  View,
} from 'react-native'

import { HeaderBackButton } from '@react-navigation/elements'
import { createStackNavigator } from '@react-navigation/stack'

import { useContent } from '@sart/content'
import { theme, colors } from '@sart/styles'
import { CompanyIcon } from '@sart/icons'

import { stackNavigationProps } from '../nagivationProps'

import BillsMenu from './BillsMenu'
import ViewBills from './ViewBills'
import ViewBill from './ViewBill'
import PayBill from './PayBill'

const Stack = createStackNavigator()

function BillsStackNavigator() {

  const content = useContent()

  return(
    <Stack.Navigator
      initialRouteName='BillsMenu'
      screenOptions={{
        ...stackNavigationProps.screenOptions
      }}
    >
      <Stack.Screen
        name="BillsMenu"
        component={BillsMenu}
        options={{
          title: "Bills",
          headerTitleStyle: theme.navigationHeader,
          headerLeft: () => (<View style={{paddingLeft: 15}}>
            <CompanyIcon color={colors.srGreen} height={60} width={60} />
          </View>)
        }}
      />
      <Stack.Screen
        name="ViewBills"
        component={ViewBills}
        options={({ navigation }) => ({
          title: "Bills",
          headerTitleStyle: theme.navigationHeader,
          headerLeft: props => (
            <HeaderBackButton
              labelVisible={true}
              onPress={() => {
                navigation.popToTop()
                navigation.navigate('BillsMenu')
              }}
            />
          )
        })}
      />
      <Stack.Screen
        name="ViewBill"
        component={ViewBill}
        options={({ navigation}) => ({
          title: "Bills",
          headerTitleStyle: theme.navigationHeader,
          headerLeft: props => (
            <HeaderBackButton
              labelVisible={true}
              onPress={() => {
                navigation.popToTop()
                navigation.navigate('BillsMenu')
              }}
            />
          )
        })}
      />
      <Stack.Screen
        name="PayBill"
        component={PayBill}
        options={({ navigation}) => ({
          title: "Pay Bill",
          headerTitleStyle: theme.navigationHeader,
          headerLeft: props => (
            <HeaderBackButton
              labelVisible={true}
              onPress={() => {
                navigation.popToTop()
                navigation.navigate('BillsMenu')
              }}
            />
          )
        })}
      />
    </Stack.Navigator>
  )
}

export default BillsStackNavigator